import React, { useState } from "react"
import { Button, Col, FormGroup, Label, Modal, ModalBody, Row } from "reactstrap"
import { useResponse } from "../../../hooks/useResponse"
import ReactSelect from "react-select"
import { languageTempletsOptions } from "../../../utils/langTemplets"
import { getPayslipPdf } from "../../../api/payslipes"

const PrintPayslipModal = ({handleClose, isOpen, payslip}) => {

  const [template, setTemplate] = useState(null)

  const empName = payslip?.employee?.name

  const {loading, error, setData} = useResponse(getPayslipPdf, (res) => {
    const blob = new Blob([res], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `payslip ${empName}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    handleClose()
    setTemplate(null)
  })

  function handlePrint(){
    setData({type: "edit", id:  payslip?.id, data: {templateKey: template?.value || null}})
  }

  return (
    <Modal isOpen={isOpen} toggle={handleClose} centered={true}>
      <ModalBody className="py-5 px-5">
        <h2 className="text-center mb-4">Printing Payslip</h2>
        
        <Row>
          <Col md={12}>
            <FormGroup className="">
                <Label>Template:</Label>
                <ReactSelect
                  options={languageTempletsOptions}
                  value={template}
                  onChange={(op) => setTemplate(op)}
                  isSearchable={false}
                  isClearable={true}
                />
            </FormGroup>
          </Col>
        </Row>          
      
        <div className="mt-4 d-flex gap-4 align-items-center justify-content-center">
          <Button
            onClick={handlePrint}
            color="primary"
            size="lg"
            disabled={loading}
          >
            {loading ? "Printing..." : "Print"}
          </Button>
          <Button onClick={handleClose} color="dark" size="lg">
            Cancel
          </Button>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default PrintPayslipModal
